import type { RouteLocationNormalized } from 'vue-router'
import { RouteName } from './routeNames'
import type { DeviceApiSdk } from '@/libs/deviceApi/DeviceApiSdk'

/**
 * Creates a navigation guard that redirects to native UI for specific frontend routes.
 *
 * This guard intercepts navigation to routes that have a corresponding client SDK
 * screen. If a native alternative exists, it triggers the opening of the native UI
 * and prevents the web application from navigating to its frontend counterpart.
 */
export const buildSdkRedirectsRouteGuard =
  (deviceApi: DeviceApiSdk) =>
  /**
   * @param to - The target RouteLocationNormalized being navigated to.
   * @returns `false` to prevent the web navigation and redirect to native UI, or `true` to allow the web navigation.
   */
  (to: RouteLocationNormalized): boolean => {
    switch (to.name) {
      case RouteName.Missions:
        deviceApi.openNativeScreen('earn_rewards')
        // Block the web route change as the native UI is being opened.
        return false
      default:
        // Allow the web route change for all other routes.
        return true
    }
  }
